// Rederive freeform paddings to center each match at the current rowHeight.
export function recenterFreeformParts(freeformParts, rowHeight) {
    const slotInset = 16;

    const parts = freeformParts ?? [];

    // Match ids that receive a cross-part loser drop. Their 1:1 winner feed lands in the
    // bottom slot (see matchIsOnTop), so they sit one inset above the feeder, not flush.
    // loserPath locates its target by part (index or identifier) plus column and row.
    const loserDropTargetIds = new Set();
    for (const part of parts) {
        for (const column of part.columns ?? []) {
            for (const match of column.matches ?? []) {
                const lp = match.loserPath;
                if (!lp) {
                    continue;
                }
                const targetPart =
                    parts.find((p) => p.identifier === lp.part) ?? parts[lp.part];
                const targetMatch =
                    targetPart?.columns?.[lp.col]?.matches?.[lp.colIndex];
                if (targetMatch) {
                    loserDropTargetIds.add(targetMatch.id);
                }
            }
        }
    }

    for (const part of parts) {
        let previousTops = null;
        const columns = part.columns ?? [];
        for (const column of columns) {
            const matches = column.matches ?? [];
            const prevTops = previousTops;
            const tops = matches.map((match, r) => {
                if (!prevTops) {
                    return r * rowHeight;
                }
                if (prevTops.length === matches.length * 2) {
                    return (prevTops[r * 2] + prevTops[r * 2 + 1]) / 2;
                }
                if (prevTops.length === matches.length) {
                    return (
                        prevTops[r] -
                        (loserDropTargetIds.has(match.id) ? slotInset : 0)
                    );
                }
                return (prevTops[0] ?? 0) + r * rowHeight;
            });

            if (tops.length > 0) {
                column.paddingTop = Math.round(tops[0]);
                matches.forEach((match, r) => {
                    match.paddingTop =
                        r === 0
                            ? 0
                            : Math.round(tops[r] - tops[r - 1] - rowHeight);
                });
            }

            previousTops = tops;
        }

        // Lifting a drop-target column can drive its paddingTop negative, pulling its
        // first row up into the column header. Shift the whole part down so nothing sits
        // above the natural first-row baseline, which preserves the lift's relative offset.
        const minPad = Math.min(0, ...columns.map((c) => c.paddingTop ?? 0));
        if (minPad < 0) {
            for (const column of columns) {
                column.paddingTop = (column.paddingTop ?? 0) - minPad;
            }
        }
    }
}
